import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * A custom element that keeps source-backed Quick Specs dimensions in sync with the selected variant.
 * The product description is product-level content, so the variant picker does not morph it.
 * This component copies the server-rendered dimension values from the fetched variant markup.
 *
 * @extends {Component}
 */
class HaciendaVariantSpecs extends Component {
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  /**
   * Copies the rendered quick-spec values from the newly fetched variant markup.
   * @param {CustomEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    event.promise
      .then((result) => {
        const detail = result?.detail;
        if (!detail?.html) return;

        const source = detail.html.querySelector('hacienda-variant-specs');
        if (!source) return;

        for (const target of this.querySelectorAll('[data-hacienda-quick-spec]')) {
          const key = target.getAttribute('data-hacienda-quick-spec');
          const replacement = source.querySelector(`[data-hacienda-quick-spec="${key}"]`);
          if (replacement) target.innerHTML = replacement.innerHTML;
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[hacienda-variant-specs] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('hacienda-variant-specs')) {
  customElements.define('hacienda-variant-specs', HaciendaVariantSpecs);
}
